import React from 'react';
import './preview-disco.sass';

export const PreviewDisco = () => {
    return (
        <div className='vv-preview-disco'>
            <div className='vv-preview-disco__baner'>
                <h2>Wersja beta dla Krakowa i okolic</h2>
                <h2>Wersja beta dla Krakowa i okolic</h2>
                <h2>Wersja beta dla Krakowa i okolic</h2>
                <h2>Wersja beta dla Krakowa i okolic</h2>
                <h2>Wersja beta dla Krakowa i okolic</h2>
                <h2>Wersja beta dla Krakowa i okolic</h2>
            </div>
        </div>
    );
};
